var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { display, justifyContent, alignItems, fontSize, height, space, width, } from 'styled-system';
import { themeHeight, themeMaxHeight, themeMaxWidth, themeWidth, } from '../../common/theme/theme';
import { FlexAlignItems, Grid } from '../../common/components/Grid';
import { ResponsiveLazyImage, ResponsiveLazyImagePropsShape, } from '../../common/components/LazyImage';
import Ratio from '../../common/components/Ratio';
import LazyCarousel from '../../common/components/LazyCarousel';
import { CenterLeftControls, CenterRightControls, } from '../../common/components/LazyCarouselControls';
import { SmallHeading } from '../../common/components/Text';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { ThemedMedia } from '../../common/components/Media';
import arrowLeftIcon from '../../common/assets/icons/arrow-left.svg';
/**
 * @TODO Code refactoring needed.
 * We should consider a refactoring of this logic involving these `SLIDES_TO_SHOW_*`
 * and `SLIDE_WIDTH_*` variables. Most of this logic was ported during the carousel
 * library migration from `nuka-carousel` to `@glidejs/glide` and it's probably no longer needed.
 * Another reason for a refactoring is that this logic is no longer accurate, for example:
 * Right below, we have `SLIDES_TO_SHOW_XL` with the value 5, assuming 5 slides should be shown in the
 * Extra Large (XL) breakpoint. However, 6 and a half slides are actually shown in the component.
 */
var IMAGE_RATIO = 0.64;
var SLIDES_TO_SHOW_XL = 5;
var SLIDES_TO_SHOW_L = 4;
var SLIDES_TO_SHOW_M = 3;
var SLIDES_TO_SHOW_S = 2;
var SLIDE_WIDTH_LARGE_DESKTOP = 0.85;
var SLIDE_WIDTH_DESKTOP = 0.85;
var SLIDE_WIDTH_TABLET = 0.72;
var SLIDE_WIDTH_MOBILE = 0.81;
var defaultEventData = {
    event: 'visualNavigationTracking',
    eventData: { placement: 'visualNavigationSlide' },
};
var VisualNavigationGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
VisualNavigationGrid.defaultProps = {
    py: 0,
    px: [3, 4, '36px', 7],
    mb: [3, 4, null, 5],
    alignItems: FlexAlignItems.CENTER,
};
var VisualNavigationTitle = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), fontSize, space);
VisualNavigationTitle.defaultProps = {
    fontSize: [5, null, null, '26px'],
    mt: 0,
    mb: ['12px', '20px', 4],
};
var SlideContainer = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n"], ["\n  ", ";\n  ", ";\n  text-decoration: none;\n  cursor: pointer;\n"])), display, space);
SlideContainer.defaultProps = {
    display: 'block',
    mr: [3, '18px', '20px', 3],
};
var SlideImage = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, width, height);
SlideImage.defaultProps = {
    display: 'block',
    width: 1,
    height: 'auto',
};
var SlideDescriptionWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  word-break: break-word;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  word-break: break-word;\n"])), display, justifyContent, alignItems, space);
SlideDescriptionWrapper.defaultProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    mt: ['10px', '11px', '15px', '12px'],
};
var SlideDescription = styled(SmallHeading)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
SlideDescription.defaultProps = __assign({}, SmallHeading.defaultProps, { as: 'p', mx: 0, my: 0, lineHeight: [2, 3, null, '26px'], fontSize: [3, 4, null, 5], fontWeight: 'normal', textAlign: 'center' });
var ArrowRight = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, space);
ArrowRight.defaultProps = {
    src: arrowLeftIcon,
    alt: '',
    themeWidth: [3, '18px', null, '20px'],
    themeMaxWidth: [3, '18px', null, '20px'],
    themeHeight: [3, '18px', null, '20px'],
    themeMaxHeight: [3, '18px', null, '20px'],
    mb: '2px',
};
function CommonVisualNavigation(props) {
    var title = props.title, items = props.items, seeAllLink = props.seeAllLink, __legacy_shop_reboot_max_width = props.__legacy_shop_reboot_max_width;
    var _a = __read(useState(0), 2), activeSlide = _a[0], setActiveSlide = _a[1];
    var renderCenterLeftControls = useCallback(function (controlProps) { return React.createElement(CenterLeftControls, __assign({ isVisualNavigation: true }, controlProps)); }, []);
    var renderCenterRightControls = useCallback(function (controlProps) { return (React.createElement(CenterRightControls, __assign({ isVisualNavigation: true, slidesToShow: true, seeAllLink: seeAllLink }, controlProps))); }, [seeAllLink]);
    var renderBottomCenterControls = useCallback((function () { return false; }), []);
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    return (React.createElement(VisualNavigationGrid, { "data-testid": "visual-navigation-grid", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
        React.createElement(VisualNavigationTitle, { "data-testid": "visual-navigation-title" }, title),
        React.createElement(ThemedMedia, null, function (matches) {
            var slidesToShow = SLIDES_TO_SHOW_S;
            if (matches.large_desktop) {
                slidesToShow = SLIDES_TO_SHOW_XL;
            }
            else if (matches.desktop) {
                slidesToShow = SLIDES_TO_SHOW_L;
            }
            else if (matches.tablet) {
                slidesToShow = SLIDES_TO_SHOW_M;
            }
            /**
             * In order to show always, for each breakpoint, a defined number of slides, we have
             * to manually set the slideWidth, to overwrite the default behaviour (=> slider-width / slides-total-number),
             * and the slidesToShow, to define the number of slides we want to show at once.
             * WARNING: If the slideWidth that is passed to Carousel is
             * changed, please update SlideContainer width values
             */
            var slideWidth = matches.desktop
                ? SLIDE_WIDTH_DESKTOP
                : matches.tablet
                    ? SLIDE_WIDTH_TABLET
                    : SLIDE_WIDTH_MOBILE;
            var isMobile = matches.tablet === false;
            return (React.createElement(LazyCarousel, { renderCenterLeftControls: renderCenterLeftControls, renderCenterRightControls: renderCenterRightControls, renderBottomCenterControls: renderBottomCenterControls, frameOverflow: matches.large_desktop ? 'hidden' : 'visible', slidesToShow: slidesToShow, slideWidth: slideWidth, 
                // WARNING: If the slideWidth that is passed to Glide Carousel is
                // changed, please update these values
                fallbackSlideWidth: [
                    SLIDE_WIDTH_MOBILE / SLIDES_TO_SHOW_S,
                    SLIDE_WIDTH_TABLET / SLIDES_TO_SHOW_M,
                    SLIDE_WIDTH_DESKTOP / SLIDES_TO_SHOW_L,
                    SLIDE_WIDTH_LARGE_DESKTOP / SLIDES_TO_SHOW_XL,
                ], scrollToTheLastSlide: isMobile, afterSlide: handleAfterSlide }, items.map(function (_a, index) {
                var link = _a.link, description = _a.description, imageProps = _a.image;
                return (React.createElement(SlideContainer, __assign({ key: "slide-" + index }, getTrackerProps(__assign({}, (index - activeSlide <= slidesToShow && {
                    'data-prefetch': true,
                }), { 'data-testid': "visual-navigation-slide-" + index, href: link }), defaultEventData)),
                    React.createElement(Ratio, { ratio: IMAGE_RATIO },
                        React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                            var thumbnail = _a.thumbnail, image = _a.image, loaded = _a.loaded;
                            return (React.createElement(SlideImage, { "data-testid": "image-slide", src: loaded ? image : thumbnail, alt: description }));
                        })),
                    React.createElement(SlideDescriptionWrapper, null,
                        React.createElement(SlideDescription, { "data-testid": "description-slide" }, description),
                        React.createElement(ArrowRight, null))));
            })));
        })));
}
CommonVisualNavigation.propTypes = {
    /** Title of the section */
    title: PropTypes.string.isRequired,
    /** Array of items */
    items: PropTypes.arrayOf(PropTypes.shape({
        /** Item's name */
        description: PropTypes.string,
        /** Item's link to redirect */
        link: PropTypes.string,
        /** Item's image */
        image: PropTypes.shape(__assign({ 
            /** Alternative image text. */
            alt: PropTypes.string }, ResponsiveLazyImagePropsShape)),
    }).isRequired),
    /** Link to listing page */
    seeAllLink: PropTypes.shape({
        /** Link's label */
        label: PropTypes.string,
        /** Link's href */
        href: PropTypes.string,
    }),
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
CommonVisualNavigation.defaultProps = {
    seeAllLink: null,
    __legacy_shop_reboot_max_width: true,
};
export default CommonVisualNavigation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
